module.exports = __webpack_public_path__ + "img/tss-9.9df45a20.jpg";